import Bookmark from "../Pages/Bookmark";
import Calender from "../Pages/Calender";
import VideoChat from "../Pages/ChatApp/VideoChat";
import VoiceChat from "../Pages/ChatApp/VoiceChat";
import ContactApp from "../Pages/Contact";
import Default from "../Pages/DashBoard/Default/Default";
import Ecommerce from "../Pages/DashBoard/Eccomerce/Ecommerce";
import AddProduct from "../Pages/Ecommerce/Addproduct";
import Cart from "../Pages/Ecommerce/Cart";
import Checkout from "../Pages/Ecommerce/Checkout";
import Invoice from "../Pages/Ecommerce/Invoice/Invoice";
import OrderHistory from "../Pages/Ecommerce/OrderHistory";
import PaymentDetail from "../Pages/Ecommerce/PaymentDetail";
import PricingCard from "../Pages/Ecommerce/Pricing";
import Product from "../Pages/Ecommerce/Product";
import ProductList from "../Pages/Ecommerce/ProductList";
import ProductPage from "../Pages/Ecommerce/ProductPage";
import WishList from "../Pages/Ecommerce/WishList";
import EmailCompose from "../Pages/Email/EmailCompose";
import EmailInBox from "../Pages/Email/EmailInBox";
import EmailRead from "../Pages/Email/EmailRead";
import FileManager from "../Pages/FileManager";
import BasicInputs from "../Pages/Form/FormControl/BasicInputs";
import CheckBoxAndRadioBtn from "../Pages/Form/FormControl/CheckBoxAndRadioBtn";
import FormValidationForm from "../Pages/Form/FormControl/FormValidation";
import InputGroupsForm from "../Pages/Form/FormControl/InputGroupsForm";
import MegaOption from "../Pages/Form/FormControl/MegaOption";
import DateAndTimePicker from "../Pages/Form/FormWidget/DateAndTimePicker";
import Datepicker from "../Pages/Form/FormWidget/Datepicker";
import DateRangePicker from "../Pages/Form/FormWidget/DateRangePicker";
import Touchspin from "../Pages/Form/FormWidget/Touchspin";
import Typeahead from "../Pages/Form/FormWidget/Typeahead";
import FormCustomSelect from "../Pages/Form/FormWidget/FormCutomSelect";
import ProjectCreate from "../Pages/Project/ProjectCreate";
import ProjectList from "../Pages/Project/ProjectList";
import SearchResult from "../Pages/SearchResult";
import SocialApp from "../Pages/SocialApp";
import Task from "../Pages/Task";
import TodoApp from "../Pages/Todo";
import UserCard from "../Pages/User/UserCard";
import UserEdit from "../Pages/User/UserEdit";
import UserProfile from "../Pages/User/UserProfile";
import ChartWidgets from "../Pages/Widgets/Chart";
import GeneralWidgets from "../Pages/Widgets/General";
import Switch from "../Pages/Form/FormWidget/Switch";
import Clipboard from "../Pages/Form/FormWidget/Clipboard";
import FormDefault from "../Pages/Form/FormLayout/FormDefault";
import FormWizardOne from "../Pages/Form/FormLayout/FormWizardOne";
import FormWizardTwo from "../Pages/Form/FormLayout/FormWizardTwo";
import FormWizardThree from "../Pages/Form/FormLayout/FormWizardThree";
import DataTable from "../Pages/Table/DataTable";
import ReactstrapTable from "../Pages/Table/ReactstrapTable";
import Typography from "../Pages/UiKit/Typography";
import Avatar from "../Pages/UiKit/Avatar";
import HelperClasses from "../Pages/UiKit/HelperClasses";
import Grid from "../Pages/UiKit/Grid";
import TagAndPills from "../Pages/UiKit/TagAndPills";
import ProgressBars from "../Pages/UiKit/ProgressBars";
import Modals from "../Pages/UiKit/Modals";
import Alert from "../Pages/UiKit/Alert";
import PopOvers from "../Pages/UiKit/PopOvers";
import Tooltips from "../Pages/UiKit/Tooltips";
import Spinner from "../Pages/UiKit/Spinner";
import Dropdowns from "../Pages/UiKit/Dropdowns";
import Accordion from "../Pages/UiKit/Accordion";
import TabBootstrap from "../Pages/UiKit/TabBootstrap";
import TabLine from "../Pages/UiKit/TabLine";
import Shadow from "../Pages/UiKit/Shadow";
import List from "../Pages/UiKit/List";
import Scrollable from "../Pages/BonuseUi/Scrollable";
import TreeView from "../Pages/BonuseUi/TreeView";
import BootstrapNotify from "../Pages/BonuseUi/BootstrapNotify";
import RatingClass from "../Pages/BonuseUi/RatingClass";
import Dropzones from "../Pages/BonuseUi/Dropzones";
import Tours from "../Pages/BonuseUi/Tours";
import SweetAlerts from "../Pages/BonuseUi/SweetAlerts";
import Carousels from "../Pages/BonuseUi/Carousels";
import Ribbons from "../Pages/BonuseUi/Ribbons";
import Paginations from "../Pages/BonuseUi/Paginations";
import BreadcrumbClass from "../Pages/BonuseUi/BreadcrumbClass";
import RangeSlider from "../Pages/BonuseUi/RangeSlider";
import Imagecropper from "../Pages/BonuseUi/Imagecropper";
import Sticky from "../Pages/BonuseUi/Sticky";
import BasicCards from "../Pages/BonuseUi/BasicCards";
import CreativeCards from "../Pages/BonuseUi/CreativeCards";
import TabCard from "../Pages/BonuseUi/TabCard";
import Timeline from "../Pages/BonuseUi/Timeline";
import FlagIcon from "../Pages/Icons/FlagIcon";
import FontawesomeIcon from "../Pages/Icons/FontawesomeIcon";
import IcoIcons from "../Pages/Icons/IcoIcons";
import ThemifyIcons from "../Pages/Icons/ThemifyIcons";
import WeatherIcons from "../Pages/Icons/WeatherIcons";
import FeatherIcon from "../Pages/Icons/FeatherIcon";
import DefaultButton from "../Pages/Button/DefaultButton";
import GroupButton from "../Pages/Button/GroupButton";
import Apexcharts from "../Pages/Chart/Apexcharts";
import GoogleCharts from "../Pages/Chart/GoogleCharts";
import Charts from "../Pages/Chart/Charts";
import SamplePage from "../Pages/SamplePage/SamplePage";
import ImageGallery from "../Pages/Gallery/ImageGallery";
import ImageWithDesc from "../Pages/Gallery/ImageWithDesc";
import MesonryGallery from "../Pages/Gallery/MesonryGallery";
import MesonryDesc from "../Pages/Gallery/MesonryDesc";
import ImageHover from "../Pages/Gallery/ImageHover";
import BlogDetail from "../Pages/Blog/BlogDetail";
import BlogSingle from "../Pages/Blog/BlogSingle";
import BlogPost from "../Pages/Blog/BlogPost";
import FAQContent from "../Pages/FAQContent/FAQContent";
import JobCards from "../Pages/JobSearch/JobCards";
import ListView from "../Pages/JobSearch/ListView";
import JobDetails from "../Pages/JobSearch/JobDetails";
import Apply from "../Pages/JobSearch/Apply";
import LearningList from "../Pages/Learning/LearningList";
import DetailCourse from "../Pages/Learning/DetailCourse";
import LeafletMap from "../Pages/Map/LeafletMap";
import CkEditor from "../Pages/Editors/CkEditor";
import MdeEDitor from "../Pages/Editors/MdeEDitor";
import ACEEditor from "../Pages/Editors/ACEEditor";
import KnowledgeBase from "../Pages/Knowledge/KnowledgeBase";
import KnowledgeCategory from "../Pages/Knowledge/KnowledgeCategory";
import KnowledgeDetail from "../Pages/Knowledge/KnowledgeDetail";
import SupportTicket from "../Pages/SupportTicket/SupportTickit";
import GoogleMap from "../Pages/Map/GoogleMap";

export const ROUTES = [
  // Deshboard
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, element: <Default /> },
  { path: `${process.env.PUBLIC_URL}/dashboards/ecommerce`, element: <Ecommerce /> },

  // Widgets
  { path: `${process.env.PUBLIC_URL}/widgets/general-widget`, element: <GeneralWidgets /> },
  { path: `${process.env.PUBLIC_URL}/widgets/chart-widget`, element: <ChartWidgets /> },

  // Project App
  { path: `${process.env.PUBLIC_URL}/project/project-list`, element: <ProjectList /> },
  { path: `${process.env.PUBLIC_URL}/project/create-project`, element: <ProjectCreate /> },

  // File Manager
  { path: `${process.env.PUBLIC_URL}/file-manager`, element: <FileManager /> },

  // Ecommerce App
  { path: `${process.env.PUBLIC_URL}/ecommerce/product`, element: <Product /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/product-page`, element: <ProductPage /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/product-list`, element: <ProductList /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/add-product`, element: <AddProduct /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/payment-details`, element: <PaymentDetail /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/order-history`, element: <OrderHistory /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/invoice`, element: <Invoice /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/cart`, element: <Cart /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/wishlist`, element: <WishList /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/checkout`, element: <Checkout /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/pricing`, element: <PricingCard /> },

  // Email App
  { path: `${process.env.PUBLIC_URL}/email/email-inbox`, element: <EmailInBox /> },
  { path: `${process.env.PUBLIC_URL}/email/email-read`, element: <EmailRead /> },
  { path: `${process.env.PUBLIC_URL}/email/email-compose`, element: <EmailCompose /> },

  // Chat App
  { path: `${process.env.PUBLIC_URL}/chat/chat`, element: <VoiceChat /> },
  { path: `${process.env.PUBLIC_URL}/chat/chat-video`, element: <VideoChat /> },

  // Users
  { path: `${process.env.PUBLIC_URL}/users/user-profile`, element: <UserProfile /> },
  { path: `${process.env.PUBLIC_URL}/users/edit-profile`, element: <UserEdit /> },
  { path: `${process.env.PUBLIC_URL}/users/user-cards`, element: <UserCard /> },

  // Bookmarks
  { path: `${process.env.PUBLIC_URL}/bookmark`, element: <Bookmark /> },

  // Contact App
  { path: `${process.env.PUBLIC_URL}/contacts`, element: <ContactApp /> },

  // Task App
  { path: `${process.env.PUBLIC_URL}/task`, element: <Task /> },

  // Calender App
  { path: `${process.env.PUBLIC_URL}/calendar-basic`, element: <Calender /> },

  // Social App
  { path: `${process.env.PUBLIC_URL}/social-app`, element: <SocialApp /> },

  // Todo App
  { path: `${process.env.PUBLIC_URL}/to-do`, element: <TodoApp /> },

  // Search Result App
  { path: `${process.env.PUBLIC_URL}/search`, element: <SearchResult /> },

  // ==Form
  // Form Controls
  { path: `${process.env.PUBLIC_URL}/forms/form-controls/form-validation`, element: <FormValidationForm /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-controls/base-input`, element: <BasicInputs /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-controls/radio-checkbox-control`, element: <CheckBoxAndRadioBtn /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-controls/input-group`, element: <InputGroupsForm /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-controls/mega-options`, element: <MegaOption /> },

  // Form Widget
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/datepicker`, element: <Datepicker /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/date-time-picker`, element: <DateAndTimePicker /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/date-range-picker`, element: <DateRangePicker /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/touch-spin`, element: <Touchspin /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/select-2`, element: <FormCustomSelect /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/typeahead`, element: <Typeahead /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/switch`, element: <Switch /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/clipboard`, element: <Clipboard /> },

  // Form Layout
  { path: `${process.env.PUBLIC_URL}/forms/form-layout/default-form`, element: <FormDefault /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-layout/form-wizard`, element: <FormWizardOne /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-layout/form-wizard-2`, element: <FormWizardTwo /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-layout/form-wizard-3`, element: <FormWizardThree /> },

  // Table
  { path: `${process.env.PUBLIC_URL}/table/bootstrap-tables/data-table`, element: <DataTable /> },
  { path: `${process.env.PUBLIC_URL}/table/bootstrap-tables/react-strap-basic`, element: <ReactstrapTable /> },

  // Ui Kit
  { path: `${process.env.PUBLIC_URL}/ui-kits/typography`, element: <Typography /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/avatars`, element: <Avatar /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/helper-classes`, element: <HelperClasses /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/grid`, element: <Grid /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tag-pills`, element: <TagAndPills /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/progress-bar`, element: <ProgressBars /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/modal-bar`, element: <Modals /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/alert`, element: <Alert /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/popover`, element: <PopOvers /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tooltip`, element: <Tooltips /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/loader`, element: <Spinner /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/dropdown`, element: <Dropdowns /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/accordion`, element: <Accordion /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tabs/tab-bootstrap`, element: <TabBootstrap /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tabs/line-tabs`, element: <TabLine /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/box-shadow`, element: <Shadow /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/list`, element: <List /> },

  // Bonus Ui
  { path: `${process.env.PUBLIC_URL}/bonus-ui/scrollable`, element: <Scrollable /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/tree`, element: <TreeView /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/bootstrap-notify`, element: <BootstrapNotify /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/rating`, element: <RatingClass /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/dropzone`, element: <Dropzones /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/tour`, element: <Tours /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/sweet-alert-2`, element: <SweetAlerts /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/carousel`, element: <Carousels /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/ribbons`, element: <Ribbons /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/pagination`, element: <Paginations /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/breadcrumb`, element: <BreadcrumbClass /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/range-slider`, element: <RangeSlider /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/image-cropper`, element: <Imagecropper /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/sticky`, element: <Sticky /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/basic-card`, element: <BasicCards /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/creative-card`, element: <CreativeCards /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/tabbed-card`, element: <TabCard /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/timeline`, element: <Timeline /> },

  // Icons
  { path: `${process.env.PUBLIC_URL}/icons/flag-icon`, element: <FlagIcon /> },
  { path: `${process.env.PUBLIC_URL}/icons/font-awesome`, element: <FontawesomeIcon /> },
  { path: `${process.env.PUBLIC_URL}/icons/ico-icon`, element: <IcoIcons /> },
  { path: `${process.env.PUBLIC_URL}/icons/themify-icon`, element: <ThemifyIcons /> },
  { path: `${process.env.PUBLIC_URL}/icons/whether-icon`, element: <WeatherIcons /> },
  { path: `${process.env.PUBLIC_URL}/icons/feather-icon`, element: <FeatherIcon /> },

  // Button
  { path: `${process.env.PUBLIC_URL}/buttons/buttons`, element: <DefaultButton /> },
  { path: `${process.env.PUBLIC_URL}/buttons/button-group`, element: <GroupButton /> },

  // Charts
  { path: `${process.env.PUBLIC_URL}/charts/chart-apex`, element: <Apexcharts /> },
  { path: `${process.env.PUBLIC_URL}/charts/chart-google`, element: <GoogleCharts /> },
  { path: `${process.env.PUBLIC_URL}/charts/chartjs`, element: <Charts /> },

  // Pages
  { path: `${process.env.PUBLIC_URL}/pages/sample-page`, element: <SamplePage /> },

  // Gallery
  { path: `${process.env.PUBLIC_URL}/gallery/gallery`, element: <ImageGallery /> },
  { path: `${process.env.PUBLIC_URL}/gallery/gallery-with-description`, element: <ImageWithDesc /> },
  { path: `${process.env.PUBLIC_URL}/gallery/gallery-masonry`, element: <MesonryGallery /> },
  { path: `${process.env.PUBLIC_URL}/gallery/masonry-gallery-with-disc`, element: <MesonryDesc /> },
  { path: `${process.env.PUBLIC_URL}/gallery/gallery-hover`, element: <ImageHover /> },

  // Blog
  { path: `${process.env.PUBLIC_URL}/blog/blog-detail`, element: <BlogDetail /> },
  { path: `${process.env.PUBLIC_URL}/blog/blog-single`, element: <BlogSingle /> },
  { path: `${process.env.PUBLIC_URL}/blog/add-post`, element: <BlogPost /> },

  // Faqs
  { path: `${process.env.PUBLIC_URL}/faq`, element: <FAQContent /> },

  // Job Search
  { path: `${process.env.PUBLIC_URL}/job-search/job-cards-view`, element: <JobCards /> },
  { path: `${process.env.PUBLIC_URL}/job-search/job-list-view`, element: <ListView /> },
  { path: `${process.env.PUBLIC_URL}/job-search/job-details`, element: <JobDetails /> },
  { path: `${process.env.PUBLIC_URL}/job-search/job-apply`, element: <Apply /> },

  // Learning
  { path: `${process.env.PUBLIC_URL}/learning/learning-list-view`, element: <LearningList /> },
  { path: `${process.env.PUBLIC_URL}/learning/learning-detail`, element: <DetailCourse /> },

  // Map
  { path: `${process.env.PUBLIC_URL}/maps/google-map`, element: <GoogleMap /> },
  { path: `${process.env.PUBLIC_URL}/maps/leaflet-map`, element: <LeafletMap /> },

  // Editors
  { path: `${process.env.PUBLIC_URL}/editors/ckeditor`, element: <CkEditor /> },
  { path: `${process.env.PUBLIC_URL}/editors/simple-MDE`, element: <MdeEDitor /> },
  { path: `${process.env.PUBLIC_URL}/editors/ace-code-editor`, element: <ACEEditor /> },

  // KnowledgeBase
  { path: `${process.env.PUBLIC_URL}/knowledgebase/knowledgebase`, element: <KnowledgeBase /> },
  { path: `${process.env.PUBLIC_URL}/knowledgebase/knowledge-category`, element: <KnowledgeCategory /> },
  { path: `${process.env.PUBLIC_URL}/knowledgebase/knowledge-detail`, element: <KnowledgeDetail /> },

  // Support Ticket
  { path: `${process.env.PUBLIC_URL}/support-ticket`, element: <SupportTicket /> },
];
